import React from "react";
import loginim from './login-img.png';

class Loginimg extends React.Component {
    render() {
        return <img src={loginim} alt="TrustEasy" />;
    }
}

export default Loginimg;